import React from "react";
import {
  Box,
  SimpleGrid,
  Image,
  Text,
  Heading,
  ChakraProps,
} from "@ssg-ui/react";

interface SimpleThumbnailItemProps extends ChakraProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
}

interface SimpleThumbnailListProps extends ChakraProps {
  data?: SimpleThumbnailItemProps[];
  title?: string;
  columns: number;
  spacingX: number;
  spacingY: number;
}

export const SimpleThumbnailList = (props: SimpleThumbnailListProps) => {
  const { data, title, columns, spacingX, spacingY, ...rest } = props;
  return (
    <Box w="full" {...rest}>
      {title && (
        <Box mb={4}>
          <Heading as="h3" fontSize="2xl">
            {title}
          </Heading>
        </Box>
      )}
      <SimpleGrid columns={columns} spacingX={spacingX} spacingY={spacingY}>
        {data?.map((item: SimpleThumbnailItemProps) => (
          <Box minW={0} key={item.title}>
            <Image src={item.imageSrc} alt={item.imageAlt} />
            <Text mt="2" fontSize="xs" align="center" letterSpacing="tight">
              {item.title}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

SimpleThumbnailList.defaultProps = {
  title: "타이틀",
  columns: 5,
  spacingX: 2,
  spacingY: 4,
  data: [
    {
      title: "우르르",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072410241275784902002590_975.png",
    },
    {
      title: " 선물하기",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072410363842768963149896_908.png",
    },
    {
      title: "프리오더",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072410260251446821647682_348.png",
    },
    {
      title: "STREET@",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072410261871615807563580_541.png",
    },
    {
      title: "SHOP@",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072316475451547406976740_891.png",
    },
    {
      title: "라이프매거진",

      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072316493261115370653537_108.png",
    },
    {
      title: "이벤트",
      imageSrc:
        "https://simg.ssgcdn.com/trans.ssg?src=/cmpt/banner/202007/2020072316511012820577774057_659.png",
    },
  ],
};
